export const WALLET_UPDATE_EVENT = '/wallet/userWalletBalance'
